import { stepSelected } from 'common/actions'
import {
  configCreditCardRewardsEnabledSelector,
  configFeatureFlagsSelector,
  configShowTrustedPartners,
} from 'embed/selectors/config'
import { MultiProductDispatch } from 'embed/constants'
import { MultiProductState } from 'embed/reducers'
import { CreditCardStep, FeatureFlag, Product, TrustedPartnersSectionLocation } from 'even-ts-static'
import * as React from 'react'
import { connect } from 'react-redux'
import { CreditCardIntro, CreditCardIntroProps } from '.'
import * as Bullets from './Bullets'
import * as TrustedPartners from './TrustedPartners'

interface DispatchProps {
  dispatchPreSelectFormStep: () => void
}

interface StoreProps {
  featureFlags: FeatureFlag[]
  rewardsEnabled: boolean
  showTrustedPartners: TrustedPartnersSectionLocation
}
export type CreditCardIntroContainerProps = StoreProps & DispatchProps

const Container = ({
  dispatchPreSelectFormStep,
  featureFlags,
  rewardsEnabled,
  showTrustedPartners,
}: CreditCardIntroContainerProps) => {
  const baseProps: CreditCardIntroProps = {
    featureFlags,
    showTrustedPartners,
    staticTrustedPartners: [
      TrustedPartners.Avant,
      TrustedPartners.Deserve,
      TrustedPartners.Upgrade,
      TrustedPartners.Jasper,
    ],
    onContinue: dispatchPreSelectFormStep,
  }

  const defaultProps: CreditCardIntroProps = {
    ...baseProps,
    bullets: [Bullets.answerQuestions, Bullets.noImpact, Bullets.quickEasy],
    header: 'Get Matched With Personalized Credit Card Offers',
  }

  const rewardsProps = {
    ...baseProps,
    bullets: [Bullets.howYouSpend, Bullets.numberCrunch, Bullets.getRec],
    header: 'Get Matched With Credit Card Offers Based On Your Spending',
  }

  return rewardsEnabled ? <CreditCardIntro {...rewardsProps} /> : <CreditCardIntro {...defaultProps} />
}

const mapStateToProps = (state: MultiProductState): StoreProps => {
  const featureFlags = configFeatureFlagsSelector(state)
  const rewardsEnabled = configCreditCardRewardsEnabledSelector(state)
  const showTrustedPartners = configShowTrustedPartners(state)

  return {
    featureFlags,
    rewardsEnabled,
    showTrustedPartners,
  }
}

const mapDispatchToProps = (dispatch: MultiProductDispatch): DispatchProps => ({
  dispatchPreSelectFormStep: () => dispatch(stepSelected(Product.CreditCard, CreditCardStep.PreSelectForm)),
})

export const CreditCardIntroContainer = connect<StoreProps, DispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(Container)
